"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.hasFilter = exports.cleanOnChangeFn = exports.updateOptions = exports.unselectOptions = exports.unhideOptions = exports.toggleSelectOptionsByGroup = exports.togglePopover = exports.toggleOptionDisabled = exports.setTriggerWidth = exports.setHeight = exports.setHasPopupOpened = exports.setHasFooter = exports.setActiveOption = exports.selectSingleOption = exports.selectMultipleOption = exports.toggleMultipleOption = exports.reset = exports.openPopover = exports.hideOptions = exports.closePopover = exports.clear = exports.cancel = exports.applyFilter = exports.accept = void 0;
var accept = "ACCEPT";
exports.accept = accept;
var applyFilter = "APPLY_FILTER";
exports.applyFilter = applyFilter;
var cancel = "CANCEL";
exports.cancel = cancel;
var clear = "CLEAR";
exports.clear = clear;
var closePopover = "CLOSE_POPOVER";
exports.closePopover = closePopover;
var hideOptions = "HIDE_OPTION";
exports.hideOptions = hideOptions;
var openPopover = "OPEN_POPOVER";
exports.openPopover = openPopover;
var reset = "RESET";
exports.reset = reset;
var toggleMultipleOption = "TOGGLE_MULTIPLE_OPTION";
exports.toggleMultipleOption = toggleMultipleOption;
var selectMultipleOption = "SELECT_MULTIPLE_OPTION";
exports.selectMultipleOption = selectMultipleOption;
var selectSingleOption = "SELECT_SINGLE_OPTION";
exports.selectSingleOption = selectSingleOption;
var setActiveOption = "SET_ACTION_OPTION";
exports.setActiveOption = setActiveOption;
var setHasFooter = "SET_HAS_FOOTER";
exports.setHasFooter = setHasFooter;
var setHasPopupOpened = "SET_HAS_POPUP_OPENED";
exports.setHasPopupOpened = setHasPopupOpened;
var setHeight = "SET_HEIGHT";
exports.setHeight = setHeight;
var setTriggerWidth = "SET_TRIGGER_WIDTH";
exports.setTriggerWidth = setTriggerWidth;
var toggleOptionDisabled = "TOGGLE_OPTION_DISABLED";
exports.toggleOptionDisabled = toggleOptionDisabled;
var togglePopover = "TOGGLE_POPOVER";
exports.togglePopover = togglePopover;
var toggleSelectOptionsByGroup = "TOGGLE_SELECT_OPTION_BY_GROUP";
exports.toggleSelectOptionsByGroup = toggleSelectOptionsByGroup;
var unhideOptions = "UNHIDE_OPTION";
exports.unhideOptions = unhideOptions;
var unselectOptions = "UNSELECT_OPTION";
exports.unselectOptions = unselectOptions;
var updateOptions = "UPDATE_OPTIONS";
exports.updateOptions = updateOptions;
var cleanOnChangeFn = "CLEAN_ON_CHANGE_FN";
exports.cleanOnChangeFn = cleanOnChangeFn;
var hasFilter = "HAS_FILTER";
exports.hasFilter = hasFilter;
//# sourceMappingURL=actionTypes.js.map